export const COLORS_CHART = [
  "#34c38f",
  "#556ee6",
  "#f46a6a",
  "#50a5f1",
  "#f1b44c",
  "#b644b8fa",
];

export const ALL_STORE = "ALL_STORE";
export const ALL_BU = "ALL_BU";

export const TYPE_FILTER_INVOICE_ERROR = {
  INVOICE: "INVOICE", // Hóa đơn
  INVOICE_WAREHOUSES: "INVOICE_WAREHOUSES", // Phiếu xuất kho vc nội bộ
  INVOICE_AGENT: "INVOICE_AGENT", // Phiếu xuất kho gửi bán đại lý
};
